<template>
  <div class="terms container">
    <b-row>
      <b-col md="10" offset-md="1">
        <h2 class="custom-title mt-5">Terms and conditions</h2>
        <HideableParagraph :text="termsParagraph" :is-hideable="false" />
        <HideableParagraph
          v-for="(block, idx) in termsInformation"
          :key="idx"
          :title="block.title"
          :text="block.text"
        />
      </b-col>
    </b-row>

    <b-row v-if="isFoundationTermsVisible">
      <b-col md="10" offset-md="1">
        <h2 class="custom-title mt-5">Foundation</h2>
        <FundingTermsUS v-if="region === 'US'" />
        <FundingTermsUK v-if="region === 'GB'" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { termsParagraph, termsInformation } from './constant';
import FundingTermsUS from '@/components/FundingTermsUS';
import FundingTermsUK from '@/components/FundingTermsUK';
import HideableParagraph from '@/components/HideableParagraph';

export default {
  name: 'TermsPage',

  components: {
    HideableParagraph,
    FundingTermsUS,
    FundingTermsUK
  },

  data() {
    return {
      termsParagraph,
      termsInformation
    };
  },

  head: {
    title: 'Terms of use | Found',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'These Found and CCT Terms and Conditions for Consumers (the "Terms") govern any online order placed by a Consumer Customer'
      }
    ]
  },

  computed: {
    ...mapGetters({
      region: 'config/region'
    }),

    isFoundationTermsVisible() {
      // return ['US', 'GB'].includes(this.region);

      return false;
    }
  }
};
</script>
